import { StoreState } from './store';
import { RegisterInputData, UserData, buildPostalCode } from '@store';

export const getLanguage = (state: StoreState): string => {
	return 'pt';
};

export const getRegisterPharmacyInputData = (state: StoreState): RegisterInputData => {
	return state.registerPharmacyState.registerInputData;
};

export const getHasAccessToken = (state: StoreState): boolean => {
	return getAccessToken(state) ? true : false;
};

export const getAccessToken = (state: StoreState): string => {
	return state.authState.auth.accessToken;
};

export const getExternalId = (state: StoreState): string => {
	return state.registerPharmacyState.externalId;
};

export const getTinId = (state: StoreState): string | undefined => {
	return state.registerPharmacyState.registerInputData.nipc
		? state.registerPharmacyState.registerInputData.nipc
		: undefined;
};

export const getPostalCode = (state: StoreState): string | undefined => {
	const registerInputData = state.registerPharmacyState.registerInputData;
	return buildPostalCode(registerInputData.postalCodePrefix, registerInputData.postalCodeSuffix);
	// return `${registerInputData.postalCodePrefix}${
	// 	registerInputData.postalCodeSuffix ? '-' + registerInputData.postalCodeSuffix : undefined
	// }`;
};

export const getUsersData = (state: StoreState): UserData[] | undefined => {
	return state.registerPharmacyState.registerInputData.usersData
		? state.registerPharmacyState.registerInputData.usersData
		: undefined;
};
